export const COMPARISON_KEY_WINS_CARD_COUNT = 6;

export const COMPARISON_KEY_WINS_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-key-wins-layout',
  PLACEHOLDER_HEADING: 'Section Heading',
  PLACEHOLDER_CARD_TITLE: 'Key Win Title',
  PLACEHOLDER_CARD_DESCRIPTION: 'Key win description text',
  DEFAULT_ALT_CARD_ICON: 'Key win icon'
} as const;
